import React from 'react'
import MarketCard from './MarketCard'

const obj = require("../../badges.json");
const AllBages = () => {
  return (
    <>
      {obj.map((value, i) => (
        <MarketCard key={i} value={value} variant="badge" category="badge" />
      ))}
    </>
  )
}

export default AllBages
